export enum AqiType {
  PM25 = 'PM2.5',
  PM10 = 'PM10',
  O3 = 'Ozone',
}
